import History from '@/classes/History.js'

let logger = {
  async log(userStore,message) {
    if(userStore){
      if(userStore.profile && userStore.profile.username && userStore.profile.role) {
        let log = new History(null, userStore.profile.username, userStore.profile.role, new Date().toLocaleDateString(), new Date().toLocaleTimeString(), message)
        await log.save()
      }else if(userStore.ip) {
        let log = new History(null, "Anonyme ("+userStore.ip+")", "user", new Date().toLocaleDateString(), new Date().toLocaleTimeString(), message)
        await log.save()
      }else{
        let log = new History(null, "Anonyme (IP inconnue)", "user", new Date().toLocaleDateString(), new Date().toLocaleTimeString(), message)
        await log.save()
      }
    }else{
      let log = new History(null, "Anonyme (IP inconnue)", "user", new Date().toLocaleDateString(), new Date().toLocaleTimeString(), message)
      await log.save()
    }
  }
}

export default logger